import { VRadio } from 'vuetify/lib/components/VRadioGroup';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRadio,_vm._g(_vm._b({staticClass:"base-radio",attrs:{"color":"primary","hide-details":""}},'v-radio',_vm.$attrs,false),_vm.$listeners),[_vm._l((_vm.$slots),function(scope,slot){return _c('template',{slot:slot},[_vm._t(slot,null,null,scope)],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }